import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpResponse, HttpEvent } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '@core/services/loading.service';
import { EMPTY, Observable, of } from 'rxjs';
import { CommonService } from '@core/services/common.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
    private totalRequests = 0;

    constructor(private loadingService: LoadingService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.method == 'POST' && request.url.match(/.rest\/inbox\/\d/g)) {
            return next.handle(request);
        }

        if (request.method == 'POST' && request.url.match(/.rest\/account\/cancel/g)) {
            return next.handle(request);
        }

        this.totalRequests++;
        this.loadingService.setLoading(true);

        return next.handle(request).pipe(
            finalize(() => {
                this.totalRequests--;
                if (this.totalRequests === 0) {
                    this.loadingService.setLoading(false);
                }
            })
        );
    }
}
